import React from 'react';
import { sentenceCase } from 'change-case';
import { PageHeader, Row, Col, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { ExportOutlined } from '@ant-design/icons';

interface JobDetailCardPropsInterface {
    data: {
        id: number | string;
        apiJobId: number | null;
        createdAt: Date | string;
        assignmentCode: string | null;
        status: string;
        pickupAt: Date | string;
        packageType: string;
        transportType: string | null;
        comment: string;
        dashboardURL?: string;
        stackId: number | null;
    };
}

const JobDetailCard: React.FC<JobDetailCardPropsInterface> = (
    props: JobDetailCardPropsInterface,
): React.ReactElement => {
    const {
        data: {
            id,
            apiJobId,
            dashboardURL,
            createdAt,
            assignmentCode,
            status,
            pickupAt,
            packageType,
            transportType,
            comment,
            stackId,
        },
    } = props;

    const jobDetailItems: { key: string; data: any }[] = [
        { key: 'jobId', data: id },
        { key: 'deliveryRequestId', data: apiJobId },
        { key: 'createdAt', data: createdAt },
        { key: 'assigmentCode', data: assignmentCode },
        { key: 'pickupAt', data: pickupAt },
        { key: 'packageType', data: packageType },
        { key: 'transportType', data: transportType },
    ];

    return (
        <div className="shadow-sm py-2">
            <PageHeader
                className="site-page-header py-2 justify-content-end"
                title={<p className="h5 m-0">Job</p>}
                extra={[
                    <p key="status">
                        <small>
                            <strong>Status:</strong>
                        </small>
                        <br />
                        <span className="text-secondary w-100 d-block">{sentenceCase(status)}</span>
                        {dashboardURL && (
                            <>
                                <a
                                    id="link-to-dashboard"
                                    href={dashboardURL}
                                    className="w-100 d-flex align-items-center"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="View on Dashboard"
                                >
                                    <ExportOutlined className="mr-2" />
                                    View on Dashboard
                                </a>
                            </>
                        )}
                    </p>,
                ]}
            />
            <div className="px-4">
                {jobDetailItems.map((item) => (
                    <Row key={item.key}>
                        <Col span={12}>{`${sentenceCase(item.key)}:`}</Col>
                        <Col span={12} className="text-secondary">
                            {item.data}
                        </Col>
                    </Row>
                ))}
                {stackId && (
                    <Row>
                        <Col span={12}>Stack id:</Col>
                        <Col span={12} className="text-secondary d-flex justify-content-between">
                            <span>{stackId}</span>
                            <Link
                                to={`/admin/stacks/detail/${stackId}`}
                                id={`stack-detail__btn-view-detail-${stackId}`}
                                title="View stack detail"
                            >
                                View stack detail
                            </Link>
                        </Col>
                    </Row>
                )}
                <Divider plain orientation="left" style={{ color: '#d9d9d9' }}>
                    <span className="text-body">
                        <strong>Comment</strong>
                    </span>
                </Divider>
                <Row>
                    <p className="text-secondary">{comment || '-'}</p>
                </Row>
            </div>
        </div>
    );
};

export default JobDetailCard;
